<template>
  <div class="plan-card-wrapper bloco-carteirinha" style="height: 100%;">
    <div v-if="plan.promotag" style="position: absolute;z-index: 999999;margin: 0;padding: 0;width: 100%;">
      <img :src="plan.promotag.url" style="width: 244px; position: absolute; top: -100px; left: 112px;" />
    </div>

    <div class="card mb-4 box-shadow plan-card" style="border-radius: 25px; height: 100%; margin: auto;">
      <div :style="headerStyle" class="card-header plan-card-header">
        <img :src="plan.img_frente" class="planos-carteirinha" style="translate: 0px -100px;" />
      </div>

      <h1 class="ps-5 pe-5 card-title plan-card-title" style="margin-top:10px; text-transform: uppercase">
        {{ planName }}
      </h1>

      <div
        class="card-body plan-card-body d-flex flex-column ps-5 pe-5 pb-5 pt-1 justify-content-between align-item-start">
        <div style="height: 100%; display: flex; flex-direction: column; align-items: start">
          <div style="text-align: left">
            <small>{{ priceLabel }}</small>

            <h1 class="card-title plan-card-title valor-plano">
              {{ formattedPrice }}
              <small v-if="showMonthlyText"> / mensais</small>
            </h1>
          </div>

          <div style="flex-grow:1" class="plan-card-content text-start p-r2" v-html="description"></div>

          <div style="width: 100%;">
            <a style="text-decoration:none;" :href="`/planos?scrolltop=${plan.id}`">
              <button class="btn btn-sm btn-outline-light btn-block btn-mais-detalhes"
                style="border-radius: 10px; width: auto; white-space: nowrap; margin-bottom: 20px;font-weight: bolder ">
                Mais detalhes
              </button>
            </a>
          </div>

          <div v-if="plan.congelado === 'N' && plan.link !== 'N'" style="width: 100%;">
            <a v-if="plan.redirect_url" id="btn-quero-este" target="_blank" :href="plan.redirect_url"
              style="border-radius: 8px;" class="btn btn-lg btn-block btn-primary plan-card-button fw-bold">
              QUERO ESTE
            </a>
            <a v-else id="btn-quero-este" :href="`/cadastro/dados-pessoais/${plan.id}`" style="border-radius: 8px;"
              class="btn btn-lg btn-block btn-primary plan-card-button fw-bold">
              QUERO ESTE
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { currency } from '../../filters/currency';
import { truncate } from '../../filters/truncate';
import Vue from 'vue';

export default Vue.extend({
  name: 'single-plan',

  props: {
    plan: {
      type: Object,
      required: true
    }
  },

  computed: {
    headerStyle() {
      const baseStyle = 'height:100px; border-radius: 25px 25px 0px 0px;';

      if (this.plan.background_image) {
        return `${baseStyle} background-image: url('${this.plan.background_image.url}'); background-position: center center; background-size: cover;`;
      }

      return baseStyle;
    },

    planName() {
      return this.plan.nome_display || this.plan.nome;
    },

    priceLabel() {
      if (this.plan.valor_livre === 'sim') {
        return 'Valor mínimo:';
      }

      if (this.plan.valor != 0) {
        return 'A partir de:';
      }

      return 'Plano';
    },

    formattedPrice() {
      if (this.plan.valor == 0) {
        return this.plan.valor_display || 'Grátis';
      }

      const value = this.plan.valor_display || this.plan.valor;
      return currency(value);
    },

    showMonthlyText() {
      return this.plan.valor_livre !== 'sim' && this.plan.valor != 0;
    },

    description() {
      if (this.plan.showcase_thema) {
        return truncate(this.plan.showcase_thema, 500);
      }

      return truncate(this.plan.vantagens, 500);
    }
  },
})
</script>
